export class Customer{
  constructor(customer){
    this.id = customer.id;
    this.first_name = customer.first_name;
    this.last_name = customer.last_name;
    this.full_name = customer.full_name;
    this.phone = customer.phone;
    this.email = customer.email;
    this.address = customer.address;
    this.city = customer.city;
    this.state = customer.state;
    this.country = customer.country;
    this.gender = customer.gender;
    this.birthday = customer.birthday;
    this.create_at = customer.create_at;
    this.update_at = customer.update_at;
    this.status = customer.status;
    this.group_id = customer.group_id;
    this.note = customer.note;
    this.parent_id = customer.parent_id;
    this.rating = customer.rating;
    this.is_yelp = customer.is_yelp;
    this.reachable_email = customer.reachable_email;
    this.reachable_push = customer.reachable_push;
    this.reachable_sms = customer.reachable_sms;
    this.visit_count = customer.visit_count;
    this.last_visited = customer.last_visited;
    this.image_url = customer.image_url;
    this.address2 = customer.address2;
    this.postal_code = customer.postal_code;
    this.is_send_sms = customer.is_send_sms;
    this.current_point = customer.current_point;
    this.lifetime_point = customer.lifetime_point;
    this.type = customer.type;
    this.yelp = customer.yelp;
    this.last_review = customer.last_review;
    this.review_type = customer.review_type;
  }
}